<template>
    <section>
        <div class="filter search_only">
            <div class="field_left">
                <p class="field">
                    <label for="searchadvertisingbanner" v-translate>Vyhledávání</label>
                    <input class="search clearable" id="vyhledavani" name="searchadvertisingbanner" size="30" v-model="searchText" type="text">
                    <a @click="clearFilter" id="advertisingbanner_delete" class="clearable_btn" :title="$gettext('Vymazat text')" :style="{display: (this.searchText ? 'inline' : 'none')}" v-translate>Vymazat</a>
                </p>
            </div>
        </div>

        <div class="table_overflow">
          <table class="vypis">
            <thead>
                <tr v-if="filteredAdvertisingBanners.length > 0">
                    <th class="no_padding drag_drop" />
                    <th class="no_padding checkbox"></th>
                    <th><span class="name"><strong v-translate>Název</strong></span></th>
                    <th><span v-translate>Přečteno na zařízení/celkem</span></th>
                    <th><span v-translate>Smazáno</span></th>
                    <th><span v-translate>Datum zobrazení</span></th>
                    <th class="no_padding edit" />
                </tr>
            </thead>
            <tbody>
                <AdvertisingBannerRow
                    v-for="advertisingBanner in filteredAdvertisingBanners"
                    :advertisingBanner="advertisingBanner"
                    :key="advertisingBanner.id"
                    :isDeletable="isEditable"
                    :id-subscriber="subscriber.id"
                    :advertisingBannerTypes="advertisingBannerTypes"
                    :selectedEntities="selectedEntities"
                    @input="select"
                    @deleteAdvertisingBanner="onDeleteAdvertisingBanner" />
                <tr v-if="filteredAdvertisingBanners.length === 0">
                  <td colspan="7" v-translate>Nebylo nalezeno žádné marketingové oznámení.</td>
                </tr>
            </tbody>
        </table>
        </div>
      <local-list-action-line
          :entities="filteredAdvertisingBanners"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="executeMultipleAction"
      ></local-list-action-line>
    </section>
</template>

<script>
import AdvertisingBannerRow from "./AdvertisingBannerRow";
import localTable from "@/components/mixins/local-table"

export default {
    name: "AdvertisingBanners",
    components: {AdvertisingBannerRow},
    mixins: [localTable],
    props: {
      subscriber: Object,
      advertisingBanners: Array,
      isEditable: Boolean,
    },
    data () {
        return {
            searchText: ""
        }
    },
    methods: {
        clearFilter() {
            this.searchText = "";
        },
        onDeleteAdvertisingBanner(id) {
            this.$emit('deleteAdvertisingBanner', id);
        },
      executeMultipleAction(action, activeKey) {
        let actionIds = this.selectedEntities.join();
        switch (action) {
          case 'delete-multi':
            this.onDeleteAdvertisingBanner(actionIds);
            break;
          default:
            this.runMultipleAction(action, activeKey);
        }
      }
    },
    computed: {
        entities(){
          return Object.values(this.filteredAdvertisingBanners);
        },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
          {value: 'delete-multi', text: this.$gettext('Smazat')}
        ];
      },
        csvHeaders(){
          return {
            'name': {name: this.$gettext('Název')},
            'recipients_devices_read': {name: this.$gettext('Přečteno na zařízení/celkem'), callback: (entity) => {return entity.recipients_devices_read +' / '+ entity.recipients_devices_read}},
            'timestamp_deleted': { name: this.$gettext('Smazáno'), callback: (entity) => {return entity.timestamp_deleted ? this.$_datetime_format(entity.timestamp_deleted) : ''}},
            'showAt': { name: this.$gettext('Datum zobrazení'), callback: (entity) => {return entity.timestamp_deleted ? this.$_datetime_format(entity.timestamp_deleted) : ''}},
          }
        },
        filteredAdvertisingBanners() {
            if (!this.searchText) {
                return this.advertisingBanners;
            }

            let searchText = this.searchText.toLowerCase();

            return this.advertisingBanners.filter((advertisingBanner) => {
                return advertisingBanner.name.toLowerCase().includes(searchText)
                    || advertisingBanner.id.toString().includes(searchText);
            });
        },
        advertisingBannerTypes() {
            return {
                'info': this.$gettext('Informativní sdělení'),
                'maintenance_info': this.$gettext('Servisní informace'),
                'new_service': this.$gettext('Nová služba'),
                'fault': this.$gettext('Porucha'),
                'maintenance': this.$gettext('Servis'),
                'billing': this.$gettext('Platby')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/advertisingBanners/AdvertisingBanners.vue